import React from "react";
import {
  Avatar,
  IconButton,
  Tooltip,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Badge,
} from "@mui/material";
import secureLocalStorage from "react-secure-storage";
import { experimentalStyled as styling } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { getDownloadURL, ref } from "firebase/storage";
import { imageDb } from "../Firebase/Config";
import ImageUpload from "../pages/ImageUpload/UploadImage";
const BootstrapDialog = styling(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function ProfileImage() {
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const firstName = user ? user.results.firstName : " ";
  const lastName = user ? user.results.lastName : " ";
  const email = user?.results.email;
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  const handleDialogClickOpen = () => {
    setOpenDialog(true);
  };
  const [imageUrl, setImageUrl] = React.useState(null);
  React.useEffect(() => {
    const fetchProfileImage = async () => {
      try {
        // Assuming the images are stored as email + file extension
        const fileName = `${email}`;

        // Create a reference to the file in Firebase storage
        const storageRef = ref(imageDb, `profile_images/${fileName}`);

        // Get the download URL
        const downloadURL = await getDownloadURL(storageRef);

        // Set the image URL in state
        setImageUrl(downloadURL);
      } catch (error) {
        console.error("Error fetching the image:", error);
      }
    };

    if (email) {
      fetchProfileImage();
    }
  }, [email]);
  return (
    <div>
      <BootstrapDialog
        style={{ margin: "auto", width: "400px" }}
        onClose={handleDialogClose}
        aria-labelledby='customized-dialog-title'
        open={openDialog}>
        <DialogTitle sx={{ m: 0, p: 1 }} id='customized-dialog-title'>
          Stock Account
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleDialogClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}>
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Typography>Profile Picture</Typography>
        </DialogContent>
        <DialogContent>
          <Typography style={{ fontSize: "12px" }}>
            A picture helps people recognize you and lets you know when you’re
            logged in to your account
          </Typography>
        </DialogContent>
        <DialogContent
          dividers
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <ImageUpload />
        </DialogContent>
      </BootstrapDialog>
      <Badge
        overlap='circular'
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        badgeContent={
          <Tooltip title='edit profile image'>
            <IconButton
              onClick={handleDialogClickOpen}
              size='small'
              style={{
                marginTop: "-7px",
                backgroundColor: "#555555",
                height: "20px",
                width: "20px",
                border: "0.5px solid #fff",
              }}>
              <EditIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          </Tooltip>
        }>
        <Avatar
          alt={firstName[0] + lastName[0]}
          src={imageUrl}
          sx={{ width: 50, height: 50 }}
        />
      </Badge>
    </div>
  );
}
